const ORGANIZATION_LABELS = {
  agence_de_gestion_de_la_logistique_des_officiels: 'AGLO',
  agence_des_systemes_d_information_et_du_numerique: 'ASIN',
  agence_des_systemes_d_information_et_du_numerique_asin: 'ASIN',
  agence_pour_la_gestion_de_la_logistique_des_officiels: 'AGLO',
  aglo: 'AGLO',
  asin: 'ASIN',
  banque_internationale_pour_l_industrie_et_le_commerce: 'BIIC',
  biic: 'BIIC',
  dei: 'DEI',
  ecobank: 'Ecobank',
  ecobank_benin: 'Ecobank',
  direction_de_l_emigration_et_de_l_immigration: 'DEI',
  direction_des_systemes_informatique_de_la_presidence: 'DSI Présidence',
  direction_des_systemes_informatiques_de_la_presidence: 'DSI Présidence',
  dsi_presidence: 'DSI Présidence',
  ministere_de_la_sante: 'Santé',
  ministere_des_affaires_etrangeres: 'Réception Passport',
  reception_passport: 'Réception Passport',
  sante: 'Santé',
};

const getRawOrganizationLabel = (organization) => {
  if (typeof organization === 'string') {
    return organization.trim();
  }

  if (organization && typeof organization === 'object') {
    if (typeof organization.name === 'string') {
      return organization.name.trim();
    }

    if (typeof organization.organizationName === 'string') {
      return organization.organizationName.trim();
    }

    if (typeof organization.label === 'string') {
      return organization.label.trim();
    }
  }

  return '';
};

const normalizeOrganizationLabel = (label) =>
  label
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/['’`]/g, ' ')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');

export const getOrganizationDisplayLabel = (organization) => {
  const rawLabel = getRawOrganizationLabel(organization);

  if (!rawLabel) {
    return '';
  }

  return ORGANIZATION_LABELS[normalizeOrganizationLabel(rawLabel)] || rawLabel;
};

export const isSAOrganization = (organization) => {
  if (!organization) return false;
  if (typeof organization === 'string') return false;
  return Boolean(
    organization.is_sa ||
      organization.type === 'SA' ||
      organization.role === 'SA' ||
      organization.is_agency ||
      organization.acronym === 'SA'
  );
};
